import { useGetOne, useRecordContext } from 'ra-core';
// import { useEffect, useRef } from 'react';
import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import type { Company } from '../../types';

export const AutoPopulateCompanyDetails = () => {
    const companyId = useWatch({ name: 'company_id' });
    const record = useRecordContext<any>();
    const recordRef = React.useRef(record);
    recordRef.current = record;
    // const { setValue } = useFormContext();
    const { setValue, getValues } = useFormContext();

    const { data: company, isFetching } = useGetOne<Company>('companies', { id: companyId }, { enabled: !!companyId });

    // const prevCompanyIdRef = useRef<any>(undefined);
    const prevCompanyIdRef = React.useRef<any>(undefined);

    // useEffect(() => {
    React.useEffect(() => {
        if (company && !isFetching) {
            // The app uses BrowserRouter, so the route lives in pathname (hash kept for HashRouter setups)
            const route = window.location.pathname + window.location.hash;
            const isDC = route.includes('delivery_challans');

            // Auto-populate customer state for GST calculations.
            // delivery_challans has no customer_state column — sending it fails the save.
            if (!isDC) {
                setValue('customer_state', company.state_abbr || '', { shouldDirty: true });
            }

            // Format address
            const fullAddress = [
                company.address,
                company.city,
                company.state_abbr,
                company.zipcode,
                company.country
            ].filter(Boolean).join(', ');

            const hasBillShip = route.includes('quotations') || route.includes('sales_orders') || route.includes('proforma_invoices');

            const hasExistingBilling = getValues('billing_address') !== undefined && getValues('billing_address') !== null;
            const hasExistingShipping = getValues('shipping_address') !== undefined && getValues('shipping_address') !== null;

            const isInitialLoad = prevCompanyIdRef.current === undefined;
            prevCompanyIdRef.current = companyId;

            if (isDC) {
                // Full billing / shipping address from the company master (not the short
                // composed one) so nothing is truncated on the challan.
                const c = company as any;
                // A company's billing/shipping_address is sometimes just "India"; only trust a real address
                const real = (v: any) => !!v && String(v).trim().length > 12;
                const billFull = real(c.billing_address) ? c.billing_address : fullAddress;
                const shipFull = real(c.shipping_address) ? c.shipping_address : billFull;
                // Saved challan with the same company: keep its stored addresses, only fill blanks.
                // (Form values may not be loaded yet when the company arrives, so read the record.)
                const record = recordRef.current;
                const sameCompany = !!record && String(record.company_id) === String(companyId);
                if (!sameCompany || !record?.bill_to_address) {
                    setValue('bill_to_address', billFull, { shouldDirty: !sameCompany });
                }
                if (!sameCompany || !record?.ship_to_address) {
                    setValue('ship_to_address', shipFull, { shouldDirty: !sameCompany });
                }
            } else if (hasBillShip) {
                if (!isInitialLoad || !hasExistingBilling) {
                    setValue('billing_address', (company as any).billing_address || fullAddress, { shouldDirty: true });
                }
                if (!isInitialLoad || !hasExistingShipping) {
                    setValue('shipping_address', (company as any).shipping_address || (company as any).billing_address || fullAddress, { shouldDirty: true });
                }
            }
        }
    }, [company, isFetching, setValue, companyId, getValues]);

    return null;
};
